module.exports = __webpack_public_path__ + "static/img/3bg_8.699d329.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_8.png
// module id = 701
// module chunks = 1